import { baseUrl, bucketUrl, auth} from "./utils";
import axios from "axios";
import {showError} from "./error";

export const SET_RESIDENCE_IMAGES = "SET_RESIDENCE_IMAGES";

export function setResidenceImages(images) {
    return {
        type: SET_RESIDENCE_IMAGES,
        images: images
    }
}

export async function loadImages( files ) {
        try {
            const images = await Promise.all(files.map(async (file) => {
                const res = await axios.get(`${baseUrl}/files/${file.key}`);
                return res.data
            }))
            return images
        }
        catch (error) {
            console.log("loadInterests - error", error);
        }
    
}

export function setResidencePic(file, residenceId) {
    return (dispatch, getState) => {
        let formData = new FormData();
        const userId = getState().user.data.id;
        formData.append("file", file);
        axios.post(`${baseUrl}/files`, formData, auth(getState))
            .then(response => {
                console.log(`POST? /files response:`, response); // DEBUG
                const id = response.data.id;
                axios.patch(`${baseUrl}/user/${userId}`, {[file]: id}, auth(getState))
                    .then(patchResponse => {
                        console.log(`PATCH /residence/${residenceId} response:`, patchResponse); // DEBUG
                    })
                    .catch(error => {
                        dispatch(showError(error.response.data.message))
                        console.log(`PATCH /user/${userId} error:`, error); // DEBUG
                    })
            })
            .catch(error => {
                dispatch(showError(error.response.data.message))
                console.log(`POST? /files error:`, error); // DEBUG
            })
    }
}

export const getImage = (key) => (dispatch, getState) => {
    return axios.get(`${bucketUrl}/${key}`)
        .then(res => {
            console.log(res)
            return res
        })
        .catch(err => {
            dispatch(showError(err.response.data.message))
            console.log(err)
        })
}